import React from 'react';
import { motion } from 'framer-motion';
import GradientMesh from './GradientMesh';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.05,
    },
  },
};

const itemVariants = {
  hidden: { y: 24, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] },
  },
};

const Hero = () => {
  return (
    <section
      id="hero"
      className="hero relative overflow-hidden"
      style={{
        paddingTop: 'clamp(6rem, 14vh, 10rem)',
        paddingBottom: 'clamp(4rem, 10vh, 8rem)',
        background: 'var(--color-bg-primary)',
      }}
    >
      <GradientMesh />

      <div className="container relative">
        <motion.div
          className="flex flex-col items-center text-center"
          style={{ maxWidth: '880px', margin: '0 auto' }}
          variants={containerVariants}
          initial="hidden"
          animate="visible"
        >
          <motion.h1
            variants={itemVariants}
            style={{
              fontSize: 'clamp(2.5rem, 6.5vw, 4.75rem)',
              fontWeight: 700,
              lineHeight: 1.05,
              letterSpacing: '-0.035em',
              color: 'var(--color-text-primary)',
              marginBottom: 'var(--spacing-lg)',
            }}
          >
            We build AI systems that{' '}
            <span className="gradient-text">do real work</span>.
          </motion.h1>

          <motion.p
            variants={itemVariants}
            style={{
              fontSize: 'clamp(1.05rem, 1.7vw, 1.25rem)',
              lineHeight: 1.55,
              color: 'var(--color-text-secondary)',
              maxWidth: '640px',
              marginBottom: 'var(--spacing-2xl)',
            }}
          >
            Production-grade AI for high-stakes environments.
            Built for teams who need it to actually work.
          </motion.p>

          <motion.div variants={itemVariants} className="flex items-center gap-md flex-wrap justify-center">
            <motion.a
              href="/discover"
              className="btn btn-primary btn-lg"
              whileHover={{ y: -2 }}
              whileTap={{ scale: 0.98 }}
              transition={{ type: 'spring', stiffness: 400, damping: 25 }}
            >
              Tell us what you&rsquo;re building
              <span style={{ marginLeft: '0.5rem' }}>→</span>
            </motion.a>

            <motion.a
              href="#projects"
              className="btn btn-secondary btn-lg"
              whileHover={{ y: -2 }}
              whileTap={{ scale: 0.98 }}
              transition={{ type: 'spring', stiffness: 400, damping: 25 }}
            >
              <span className="hidden-mobile">
                View Projects
                <span style={{ marginLeft: '0.5rem' }}>→</span>
              </span>
              <span className="hidden-desktop">
                View Projects
                <span style={{ marginLeft: '0.5rem' }}>→</span>
              </span>
            </motion.a>
          </motion.div>
        </motion.div>
      </div>

      <style>{`
        .hidden-desktop { display: none; }
        @media (max-width: 767px) {
          .hidden-desktop { display: inline; }
          .hidden-mobile { display: none !important; }
        }
      `}</style>
    </section>
  );
};

export default Hero;
